export default function isKey<TValue extends object>(
  a: TValue,
  key: string | number | symbol,
): key is keyof TValue {
  // eslint-disable-next-line no-prototype-builtins
  return key in a && a.hasOwnProperty(key);
}
